module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("JRの割引計算機")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("運賃（円）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.basicFee),
      expression: "basicFee",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.basicFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basicFee = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("特急料金（円）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.expressFee),
      expression: "expressFee",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.expressFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expressFee = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buyTwoWayTicket),
      expression: "buyTwoWayTicket"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.buyTwoWayTicket) ? _vm._i(_vm.buyTwoWayTicket, null) > -1 : (_vm.buyTwoWayTicket)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.buyTwoWayTicket,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.buyTwoWayTicket = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.buyTwoWayTicket = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.buyTwoWayTicket = $$c
        }
      }
    }
  }), _vm._v("\n      往復切符を買う\n    ")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buyTwoWayTicket),
      expression: "buyTwoWayTicket"
    }]
  }, [_c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useTwoWayDiscount),
      expression: "useTwoWayDiscount"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useTwoWayDiscount) ? _vm._i(_vm.useTwoWayDiscount, null) > -1 : (_vm.useTwoWayDiscount)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.useTwoWayDiscount,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.useTwoWayDiscount = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.useTwoWayDiscount = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useTwoWayDiscount = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': _vm.isTwoWayDiscountInvalid
    }
  }, [_vm._v("\n            往復割を使う\n          ")])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.useTwoWayDiscount),
      expression: "useTwoWayDiscount"
    }]
  }, [_c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.twoWayDiscountCheck1),
      expression: "twoWayDiscountCheck1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.twoWayDiscountCheck1) ? _vm._i(_vm.twoWayDiscountCheck1, null) > -1 : (_vm.twoWayDiscountCheck1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.twoWayDiscountCheck1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.twoWayDiscountCheck1 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.twoWayDiscountCheck1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.twoWayDiscountCheck1 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.twoWayDiscountCheck1
    }
  }, [_vm._v("\n                片道601km以上である（東京ー大阪間は不可）\n              ")])])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.twoWayDiscountCheck2),
      expression: "twoWayDiscountCheck2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.twoWayDiscountCheck2) ? _vm._i(_vm.twoWayDiscountCheck2, null) > -1 : (_vm.twoWayDiscountCheck2)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.twoWayDiscountCheck2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.twoWayDiscountCheck2 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.twoWayDiscountCheck2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.twoWayDiscountCheck2 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.twoWayDiscountCheck2
    }
  }, [_vm._v("\n                乗車券の有効日数を超える場合は往復切符を買うことができないことを知っている"), _c('br'), _vm._v("\n                （"), _c('a', {
    attrs: {
      "href": "https://www.jreast.co.jp/kippu/04.html"
    }
  }, [_vm._v("乗車券の有効期間｜きっぷのルール：JRおでかけネット")]), _vm._v("）\n              ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useStudentDiscount),
      expression: "useStudentDiscount"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useStudentDiscount) ? _vm._i(_vm.useStudentDiscount, null) > -1 : (_vm.useStudentDiscount)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.useStudentDiscount,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.useStudentDiscount = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.useStudentDiscount = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useStudentDiscount = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': _vm.isStudentDiscountInvalid
    }
  }, [_vm._v("\n        学割を使う\n      ")])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.useStudentDiscount),
      expression: "useStudentDiscount"
    }]
  }, [_c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentDiscountCheck1),
      expression: "studentDiscountCheck1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.studentDiscountCheck1) ? _vm._i(_vm.studentDiscountCheck1, null) > -1 : (_vm.studentDiscountCheck1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.studentDiscountCheck1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.studentDiscountCheck1 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.studentDiscountCheck1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.studentDiscountCheck1 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.studentDiscountCheck1
    }
  }, [_vm._v("\n            片道101km以上である\n          ")])])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentDiscountCheck2),
      expression: "studentDiscountCheck2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.studentDiscountCheck2) ? _vm._i(_vm.studentDiscountCheck2, null) > -1 : (_vm.studentDiscountCheck2)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.studentDiscountCheck2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.studentDiscountCheck2 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.studentDiscountCheck2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.studentDiscountCheck2 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.studentDiscountCheck2
    }
  }, [_vm._v("\n            乗車券の有効日数を超える場合は往復切符を買うことができないので，往路と復路で学割証が2枚必要なことを知っている"), _c('br'), _vm._v("\n            （"), _c('a', {
    attrs: {
      "href": "https://www.jreast.co.jp/kippu/04.html"
    }
  }, [_vm._v("乗車券の有効期間｜きっぷのルール：JRおでかけネット")]), _vm._v("）\n          ")])])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentDiscountCheck3),
      expression: "studentDiscountCheck3"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.studentDiscountCheck3) ? _vm._i(_vm.studentDiscountCheck3, null) > -1 : (_vm.studentDiscountCheck3)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.studentDiscountCheck3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.studentDiscountCheck3 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.studentDiscountCheck3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.studentDiscountCheck3 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.studentDiscountCheck3
    }
  }, [_vm._v("\n            大都市近郊区間では往復券は発売当日のみ有効で，日が変わる場合には往路と復路で学割証が2枚必要なことを知っている"), _c('br'), _vm._v("  \n            （"), _c('a', {
    attrs: {
      "href": "https://www.jr-odekake.net/railroad/ticket/guide/02b.html#5"
    }
  }, [_vm._v("大都市近郊区間内のみをご利用になる場合の特例｜きっぷのルール：JRおでかけネット")]), _vm._v("）\n          ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWarning),
      expression: "showWarning"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("チェックボックスを確認してください")]), _vm._v(" "), _c('b', [_vm._v("結果")]), _vm._v(" " + _vm._s(_vm.formula) + " = " + _vm._s(_vm.amount) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-52aa5f48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 12
// module chunks = 1